import get from 'lodash/get';

const isPaywallEligible = article => {
  // Manual check of article exemption by filelocation
  const manualArticleExemption = post => {
    const articleFilelocation = get(post, 'slug', '');
    const exemptArticleArray = [
      '5-good-ways-to-answer-the-question-how-are-you',
      'instagram-profile-pronouns-heres-how-to-display-your-gender-identity',
      'six-months-after-tumblrs-nsfw-ban-these-kink-communities-are-coming-out-on-top',
      'this-is-the-right-way-to-reply-to-a-recruiter-message-on-linkedin',
      'an-illustrated-guide-to-recognizing-your-gay-stereotypes',
      'best-sustainable-clothing-brands',
      'this-big-screen-video-chat-trick-will-help-you-cope-with-staying-home',
      'these-are-the-emails-you-should-send-when-you-start-a-new-job'
    ];
    return exemptArticleArray.includes(articleFilelocation);
  };

  // Slow rollout logic
  const checkRollout = () => {
    // Exemption via date
    const articlePubdate = get(article, 'datePublished', '');
    return articlePubdate.includes('2019-');
  };

  const postTags = get(article, 'tags', []);
  const isSponsored =
    postTags.filter(tag => tag.name.includes('_advertorial')).length > 0;
  const isManuallyExempt = manualArticleExemption(article);
  const isInRollout = checkRollout(article);

  if (isSponsored || isManuallyExempt || !isInRollout) {
    // Not eligible
    return false;
  }

  return true;
};

export default isPaywallEligible;
